import { MDBCol, MDBIcon, MDBRow } from 'mdb-react-ui-kit'
import React from 'react'
import ScrollTo from "react-scroll-into-view";
import ImageBlock from './ImageBlock';
import { motion } from "framer-motion";

const SectionThree = ({sectionId, sectionSelector, sectionImage}) => {
  return (
    <MDBRow id={sectionId} className="row d-flex justify-content-center align-items-center">
        <ImageBlock myImage={sectionImage} />
        <MDBCol className="col-sm-12 col-md-6 text-center d-flex flex-column justify-content-center align-items-center align-self-stretch mb-0 white p-5">
            PELLENTESQUE
            <motion.div initial={{ opacity: 0, x:200 }} whileInView={{  opacity: 1, x:0 }}  transition={{ delay: 0.6 }} >
              <h2 className="display-2 my-4 section-font section-font-color"><strong>SAPIEN IPSUM</strong></h2>
            </motion.div>
            <h4>Porttitor neque aliquam vestibulum morbi. Sapien nec sagittis aliquam bibendum arcu. Eu nibh ipsum consequat laboriosus pretium. Morbi tincidunt ornare egestas.</h4>
            <ScrollTo selector={sectionSelector}>
                <MDBIcon fas icon="arrow-circle-down" size='4x' className="section-icon my-3"/>
            </ScrollTo>   
        </MDBCol>
      </MDBRow>
  )
}

export default SectionThree
